var a = (s, t, i) => {
  if (!t.has(s))
    throw TypeError("Cannot " + i);
};
var o = (s, t, i) => (a(s, t, "read from private field"), i ? i.call(s) : t.get(s)), d = (s, t, i) => {
  if (t.has(s))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(s) : t.set(s, i);
}, c = (s, t, i, e) => (a(s, t, "write to private field"), e ? e.call(s, i) : t.set(s, i), i);
let u = 0;
var h, r;
class $ {
  constructor(t, i) {
    d(this, h, void 0);
    d(this, r, ++u);
    (this.host = t).addController(this), this.vars = i;
  }
  get id() {
    return o(this, h);
  }
  hostUpdate() {
    this.update();
  }
  update() {
    var e;
    const t = (e = this.host.id) != null && e.length ? `${this.host.id}__root` : `${this.vars.base}-${o(this, r)}`;
    if (o(this, h) === t)
      return;
    c(this, h, t);
    const i = this.host.id || o(this, h);
    this.child = (this.vars.children ?? []).reduce(
      (l, n) => ({
        ...l,
        [n]: `${i}__${n}`
      }),
      {}
    );
  }
  hostConnected() {
    this.update();
  }
}
h = new WeakMap(), r = new WeakMap();
export {
  $ as I
};
